import UploadSignedDoc from "./UploadSignedDoc";

export default UploadSignedDoc;
